import {
  createJobHiredReview,
  createJobNotHiredReview,
  createJobReviewPayment,
  getJobHiredReview,
  getJobNotHiredReview,
  getJobReviewPayment,
} from '@homeservices/api-kit/proreferral/reviews/v2';

export const HIRED_TYPE = 'hired';
export const NOT_HIRED_TYPE = 'not-hired';

export default {
  namespaced: true,
  state () {
    return {
      reviews: {},
      reviewTypes: {},
    };
  },
  getters: {
    getReview: state => (jobId, skillsProfileId) => {
      const reviewId = `${jobId}-${skillsProfileId}`;
      return state.reviews[reviewId];
    },
    getReviewType: state => (jobId, skillsProfileId) => {
      const reviewId = `${jobId}-${skillsProfileId}`;
      return state.reviewTypes[reviewId];
    },
  },
  actions: {
    async fetchReview ({ commit }, { jobId, skillsProfileId, cancelToken }) {
      let hasHiredReview = true;
      let hasNotHiredReview = true;
      let hasPaymentInfo = true;

      const [hiredReviewRes, notHiredReviewRes, paymentRes] = await Promise.all([
        getJobHiredReview(jobId, skillsProfileId, cancelToken).catch(() => {
          hasHiredReview = false;
          return Promise.resolve({});
        }),
        getJobNotHiredReview(jobId, skillsProfileId, cancelToken).catch(() => {
          hasNotHiredReview = false;
          return Promise.resolve({});
        }),
        getJobReviewPayment(jobId, skillsProfileId, cancelToken).catch(() => {
          hasPaymentInfo = false;
          return Promise.resolve({});
        }),
      ]);

      if (hasHiredReview || hasNotHiredReview || hasPaymentInfo) {
        const type = hasHiredReview ? HIRED_TYPE : NOT_HIRED_TYPE;

        commit('addReview', {
          jobId,
          skillsProfileId,
          type,
          reviewData: { ...hiredReviewRes.data, ...paymentRes.data, ...notHiredReviewRes.data },
        });
      }
    },
    async sendHiredReview ({ commit, dispatch }, { jobId, skillsProfileId, params }) {
      const promises = [createJobHiredReview(jobId, skillsProfileId, {
        review: params.review,
        rating: params.rating,
      })];
      if (params.amount) {
        promises.push(createJobReviewPayment(jobId, skillsProfileId, {
          amount: params.amount,
          outside_payment: params.outside_payment,
        }));
      }

      const [reviewRes, paymentRes] = await Promise.all(promises);
      const reviewData = paymentRes ? { ...reviewRes.data, ...paymentRes.data } : reviewRes.data;

      dispatch('consumer/jobs/fetchJob', { id: jobId }, { root: true });
      commit('addReview', {
        jobId,
        skillsProfileId,
        type: HIRED_TYPE,
        reviewData,
      });
    },
    async sendNotHiredReview ({ commit, dispatch }, { jobId, skillsProfileId, params }) {
      const response = await createJobNotHiredReview(jobId, skillsProfileId, params);
      dispatch('consumer/jobs/fetchJob', { id: jobId }, { root: true });
      commit('addReview', {
        jobId,
        skillsProfileId,
        type: NOT_HIRED_TYPE,
        reviewData: response.data,
      });
    },
  },
  mutations: {
    addReview (state, { jobId, skillsProfileId, type, reviewData }) {
      const reviewId = `${jobId}-${skillsProfileId}`;

      state.reviews = {
        ...state.reviews,
        [reviewId]: reviewData,
      };

      state.reviewTypes = {
        ...state.reviewTypes,
        [reviewId]: type,
      };
    },
  },
};
